import { render } from "./S110976.vue?vue&type=template&id=0d56ee90"
const script = {}
script.render = render

export default script